// extracted by mini-css-extract-plugin
export default {"header":"header_header__Iv-VS","links":"header_links__w4HQ5","stylist":"header_stylist__52EVB","model":"header_model__bHZ-n","ambassador":"header_ambassador__270TF"};